import { parseISO, isValid, formatISO, addMinutes } from 'date-fns';

/**
 * Get the initial MTA start date.
 * This function takes a date string, parses it, and returns a formatted ISO date string.
 * If the date string is invalid or not provided, it defaults to the current date and time plus 15 minutes.
 * @param date - An optional date string to parse. If not provided or invalid, defaults to the current date.
 * @returns The formatted initial MTA start date.
 */
function getInitialMTAStartDate(date?: string) {
	let baseDate: Date;
	if (date) {
		const parseDate = parseISO(date);
		if (isValid(parseDate)) {
			baseDate = parseDate;
		} else {
			baseDate = new Date();
		}
	} else {
		baseDate = new Date();
	}
	return formatISO(addMinutes(baseDate, 15));
}

export default getInitialMTAStartDate;
